// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Stdlib__List from "melange/list.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function BlogPost(Props) {
  let page = Props.page;
  const language = Buhta_landing__Route.getLanguage(undefined);
  const intl = ReactIntl.useIntl();
  let tag;
  try {
    tag = Stdlib__List.hd(Stdlib__List.filter((function (t) {
      return t !== "Избранное";
    }), page.tags));
  }
  catch (exn){
    tag = "";
  }
  const readingTime = page.readingTime;
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const result = match[0].blogPosts;
  const pages = Belt__Belt_List.keep(result.results, (function (p) {
    const pageId = page.id.replace("wiki_page_", "");
    const pId = p.id.replace("wiki_page_result_", "");
    return pageId !== pId;
  }));
  const otherPages = Belt__Belt_List.keepWithIndex(pages, (function (param, idx) {
    return idx < 4;
  }));
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("p", {
        children: [
          JsxRuntime.jsx("span", {
            children: tag,
            className: "underline"
          }),
          " ･ ",
          page.title
        ],
        className: "paragraph-small text-gray-landing"
      }),
      JsxRuntime.jsx("img", {
        className: "mt-6 lg:mt-10 h-47 lg:h-100 w-full lg:w-200 object-cover",
        alt: "Photo",
        src: page.imgUrl
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "#" + tag,
                className: "paragraph-small-medium text-primary"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: page.author,
                    className: "paragraph-small text-black-landing"
                  }),
                  JsxRuntime.jsxs("p", {
                    children: [
                      page.createdAtLongStr,
                      " ･ ",
                      String(readingTime),
                      Buhta_landing__I18n.trans(intl, "blog_min_read")
                    ],
                    className: "paragraph-small text-gray-landing ml-2"
                  })
                ],
                className: "flex mt-1 lg:mt-0"
              })
            ],
            className: "lg:flex mt-4 justify-between flex-wrap"
          }),
          JsxRuntime.jsx("h2", {
            children: page.title,
            className: "h4 lg:h2 text-black-landing mt-4"
          }),
          JsxRuntime.jsx("div", {
            className: "mt-6 lg:mt-10 content-container heading-anchor",
            dangerouslySetInnerHTML: {
              __html: page.render
            }
          }),
          JsxRuntime.jsx("hr", {
            className: "text-divider mt-6 lg:mt-10"
          }),
          JsxRuntime.jsx("h6", {
            children: Buhta_landing__I18n.trans(intl, "blog_also_read"),
            className: "h6 text-black-landing mt-6 lg:mt-10 mb-2"
          }),
          Belt__Belt_List.toArray(Stdlib__List.map((function (pg) {
            const Key = pg.id;
            return JsxRuntime.jsx(Buhta_landing__Link.make, {
              route: {
                TAG: /* Landing */ 0,
                _0: /* COUNTRY_KAZ */ 1,
                _1: language,
                _2: {
                  TAG: /* BlogPost */ 2,
                  _0: pg.slug
                }
              },
              className: "paragraph text-primary underline mt-2 block",
              children: pg.title
            }, Key);
          }), otherPages))
        ]
      })
    ],
    className: "px-6 sm:px-48 lg:px-0"
  });
}

const make = BlogPost;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
